import { render } from "./clock.vue?vue&type=template&id=e383db42&scoped=true"
import script from "./clock.vue?vue&type=script&lang=js"
export * from "./clock.vue?vue&type=script&lang=js"

import "./clock.vue?vue&type=style&index=0&id=e383db42&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e383db42"]])

export default __exports__